export const STANDARD_INSURANCE_DOMAIN_PREFIX = "standardinsurance";
export const DOMAIN_THEME_PREFIX_MTEK = "mtek";
export const DOMAIN_THEME_PREFIX_BOLTTECH = "bolttech";